import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetSocialDashboardV1Response } from './get-social-dashboard-v1-response';
import { getSocialDashboardV1ResponseSchema } from './get-social-dashboard-v1-response';

export async function getSocialDashboardV1Api(): Promise<
  IValidatedResponse<IGetSocialDashboardV1Response>
> {
  return getRequest<IGetSocialDashboardV1Response>({
    path: '/sys/social/v1/dashboard',
    schema: getSocialDashboardV1ResponseSchema,
  });
}
